import styled from 'styled-components';

import type { EmployerData } from '@xing-com/crate-jobs-helpers';
import { spaceS, spaceXXL, xdlColorBackgroundTertiary } from '@xing-com/tokens';

import { ModuleTitle } from '../module-title';

import { Benefits } from './benefits';
import { Culture } from './culture';
import { Kununu } from './kununu';

const ModuleWrapper = styled.div`
  background-color: ${xdlColorBackgroundTertiary};
  border-radius: ${spaceS};
  padding: ${spaceXXL};
`;

type Props = {
  employerData?: EmployerData;
  jobId: string;
};

export const EmployerModule: React.FC<Props> = ({ employerData, jobId }) => {
  if (!employerData) return null;

  const { culture, kununu, benefits } = employerData;

  return kununu ? (
    <>
      <ModuleTitle titleKey="JOBS_JOB_DETAILS_KUNUNU_TITLE" size="large" />
      <ModuleWrapper data-testid="employer-review-module">
        <Kununu kununuData={kununu} jobId={jobId} />
        <Benefits benefits={benefits} />
        {culture ? (
          <Culture
            culture={culture}
            ratingCount={kununu.ratingCount}
            jobId={jobId}
          />
        ) : null}
      </ModuleWrapper>
    </>
  ) : null;
};
